import { useMutation } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';
import { AxiosError } from 'axios';
import { AttendanceStatus } from '../../../types/Event';

export const updateEventAttendance = async (uuid: string, status: AttendanceStatus) => {
  return await CustomAxios.put(`events/${uuid}/update_attendance`, { status });
};

interface UseUpdateEventAttendanceProps {
  uuid: string;
  onSuccessCallback?: () => void;
}

export function useUpdateEventAttendance({ uuid, onSuccessCallback }: UseUpdateEventAttendanceProps) {
  return useMutation({
    mutationFn: (status: AttendanceStatus) => updateEventAttendance(uuid, status),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.allEvents, uuid] });
      queryClient.invalidateQueries({ queryKey: [queryKeys.eventAttendance] });
      onSuccessCallback?.();
    },
    onError: (err: AxiosError) => {
      console.log(err.response);
    },
  });
}
